import React from 'react';
import ServerMobilebillingapp from './server/Mobilebillingapp';

/**
 * Mobile Billing App — the APK backup register. apk_backup lives only in the master
 * DB, so there is a single server-side view of this page for every role; what a user
 * may see and edit is scoped inside the content component (and re-checked server side).
 */
const Mobilebillingapp = () => <ServerMobilebillingapp />;

export default Mobilebillingapp;
